/**
 * Mockup JS pouze pro styleguide šablony. Webpack výstup z tohoto souoru by neměl být použitý ve Vue / Nette aplikaci,
 * jde pouze o prototyp pro zobrazení základních UI interakcí. Scripty například nereagují na změny v DOM (např. při
 * ajaxových požadavcích), atd.
 */
import './orderMockUp/assets'

import './orderMockUp/formBoolToggle'
import './orderMockUp/dateInput'
import './orderMockUp/pdModal'

// Webpack HMR
if (module.hot) {
	module.hot.accept()
}
